import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { databaseService } from '../../services/database.service';
import AdminLayout from '../../components/layout/AdminLayout';
import Card from '../../components/common/Card';
import Button from '../../components/common/Button';
import { FaImages, FaEnvelope, FaPlus } from 'react-icons/fa';

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    galleryItems: 0,
    contactSubmissions: 0,
    unreadSubmissions: 0
  });
  const [recentSubmissions, setRecentSubmissions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [galleryItems, submissions] = await Promise.all([
          databaseService.getAllGalleryItems(),
          databaseService.getContactSubmissions(10)
        ]);

        setStats({
          galleryItems: galleryItems.length,
          contactSubmissions: submissions.length,
          unreadSubmissions: submissions.filter(s => !s.read).length
        });

        setRecentSubmissions(submissions.slice(0, 5));
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      }
    };

    fetchData();
  }, []);

  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
          <p className="text-gray-600">Welcome to your admin dashboard</p>
        </div>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm">Gallery Items</p>
                <p className="text-3xl font-bold text-gray-900">{stats.galleryItems}</p>
              </div>
              <FaImages className="text-primary-600 text-4xl" />
            </div>
          </Card>

          <Card>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm">Total Submissions</p>
                <p className="text-3xl font-bold text-gray-900">{stats.contactSubmissions}</p>
              </div>
              <FaEnvelope className="text-primary-600 text-4xl" />
            </div>
          </Card>

          <Card>
            <div className="flex items-center justify-between">
              <div>
                <p className="text-gray-600 text-sm">Unread Messages</p>
                <p className="text-3xl font-bold text-gray-900">{stats.unreadSubmissions}</p>
              </div>
              <div className="bg-red-100 rounded-full p-3">
                <FaEnvelope className="text-red-600 text-2xl" />
              </div>
            </div>
          </Card>
        </div>

        {/* Quick Actions */}
        <Card>
          <h2 className="text-xl font-semibold mb-4">Quick Actions</h2>
          <div className="flex flex-wrap gap-3">
            <Link to="/admin/gallery">
              <Button variant="primary">
                <FaPlus className="mr-2" /> Add Gallery Item
              </Button>
            </Link>
            <Link to="/admin/contacts">
              <Button variant="secondary">View Submissions</Button>
            </Link>
            <Link to="/admin/settings">
              <Button variant="secondary">Settings</Button>
            </Link>
          </div>
        </Card>

        {/* Recent Submissions */}
        {recentSubmissions.length > 0 && (
          <Card>
            <h2 className="text-xl font-semibold mb-4">Recent Contact Submissions</h2>
            <div className="space-y-3">
              {recentSubmissions.map((submission) => (
                <div
                  key={submission.id}
                  className="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
                >
                  <div>
                    <p className="font-medium">{submission.name}</p>
                    <p className="text-sm text-gray-600">{submission.subject}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm text-gray-500">
                      {new Date(submission.submittedAt).toLocaleDateString()}
                    </p>
                    {!submission.read && (
                      <span className="text-xs bg-red-100 text-red-600 px-2 py-1 rounded">
                        Unread
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <Link to="/admin/contacts">
              <Button variant="outline" className="w-full mt-4">
                View All Submissions
              </Button>
            </Link>
          </Card>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;
